import React from "react";

const Java_floorDiv = () => {
  return (
    <div>
      <h1>Java floorDiv</h1>
      <p>This page provides explanations, examples, and common use-cases for Java floorDiv in Java.</p>
    </div>
  );
};

export default Java_floorDiv;
